import Model from '/lib/model'

export default \
class Venue extends Model
  @className: 'Attraction'
  constructor: ->
    super arguments...
    @id                 = null
    @ticketmaster_id    = null
    @name               = null
    @address            = {}
    @facility_fee       = 0.0
    @created_at         = null
    @updated_at         = null

  @computed 'persisted', ->
    !! @created_at
